var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.615 20C5.155 20 4.771 19.846 4.463 19.538C4.15433 19.2293 4 18.845 4 18.385V5.615C4 5.155 4.15433 4.771 4.463 4.463C4.771 4.15433 5.155 4 5.615 4H12.019V5H5.615C5.46167 5 5.32067 5.064 5.192 5.192C5.064 5.32067 5 5.46167 5 5.615V18.385C5 18.5383 5.064 18.6793 5.192 18.808C5.32067 18.936 5.46167 19 5.615 19H12.019V20H5.615ZM16.462 15.538L15.76 14.819L18.079 12.5H9.192V11.5H18.079L15.759 9.18L16.462 8.462L20 12L16.462 15.538Z",
    fill: "#5F6388"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogout);
export default __webpack_public_path__ + "static/media/newLogout.5e6d61fb4974efc5a1367f975fcdec9d.svg";
export { ForwardRef as ReactComponent };